import { DPCustomer } from './dp-customer';



export class DPAccount {
    account_id: number;
    account_name: string;
    primary_contact_name: string;
    primary_contact_email: string;
    home_market: number;
    status: number;
    subscription_start: string;
    historical_data_offset: number;
    customer: DPCustomer;
    customer_id: number;
    account_type: string;

    constructor() {
        this.customer = new DPCustomer();
    }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-account.ts